// CreditContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { HttpRequest } from '../services/httpRequest';
import moment from 'moment';
import { IndexedDBService } from '../services/indexedDbService';

// Crea el contexto
const CreditContext = createContext();

const indexedDbService = new IndexedDBService();

// Crea el provider
export const CreditProvider = ({ children }) => {
  const [creditInfo, setCreditInfo] = useState(null);
  const [quotaInfo, setQuotaInfo] = useState(null);
  const [creditId, setCreditId] = useState(null);
  const [disclosures, setDisclosures] = useState(() => {
    const savedDisclosures = localStorage.getItem('disclosures');
    return savedDisclosures ? JSON.parse(savedDisclosures) :
      {
        showInviteFriends: false,
        showPaymentReminder: false,
        showAlertPaymentCreditToday: false,
        showAlertCreditDefault: false,
        showAlertQuotaAvailable: false,
        showAlertRewardAvailable: false,
      }
  });
  const [due, setDue] = useState(0);

  // Función para obtener la información del crédito utilizando el ID
  const fetchCreditInfo = async (id) => {
    try {
      const { message } = await HttpRequest.getCreditById(id);
      setCreditInfo(message?.info);
    } catch (error) {
      console.error('Error al obtener la información del crédito:', error);
    }
  };

  // Efecto para obtener la información del crédito cuando se actualiza el creditId
  useEffect(() => {
    if (creditId) {
      fetchCreditInfo(creditId);
    }
  }, [creditId]);


  // Efecto para validar y actualizar los Disclosures según la información del crédito
  useEffect(() => {

    const handleFindPendingsRewards = async () => {
      try {
        let _pendingsRewards = 0;
        let idRewards = 'rewards';
        let item = await indexedDbService.findItem('id', idRewards);
        if (item) {
          _pendingsRewards = item.rewardsPending;
        }
        return _pendingsRewards;
      } catch (error) {
        console.log(error);
      }
    }

    handleFindPendingsRewards()
      .then((_pendingsRewards) => {
        if (_pendingsRewards > 0) {
          setDisclosures({ showAlertRewardAvailable: true });
        } else {
          if (creditInfo) {
            if (creditInfo?.status === 'Vigente') {
              const currentDate = moment();
              const dueDate = moment(creditInfo?.paydayLimit, 'DD/MM/YYYY');
              let differenceInDays = dueDate.diff(currentDate, 'days');
              differenceInDays = differenceInDays > 0 ? differenceInDays + 1 : differenceInDays;
              setDue(differenceInDays);

              setDisclosures({
                showInviteFriends: differenceInDays > 6,
                showPaymentReminder: differenceInDays >= 1 && differenceInDays <= 5, // Ejemplo: Recordatorio de pago entre menos de 5 días y mayor a un día
                showAlertPaymentCreditToday: differenceInDays === 0,
                showAlertCreditDefault: differenceInDays < 0,
                showAlertRewardAvailable: false,
              });
            } else if (creditInfo?.status === 'Cancelado' && quotaInfo && parseInt(quotaInfo?.cupoDisponible) > 0) {
              setDisclosures({ showAlertQuotaAvailable: true });
            }
          }
        }
      });
  }, [creditInfo]);

  // Efecto para guardar en localStorage cada vez que disclosures cambie
  useEffect(() => {
    localStorage.setItem('disclosures', JSON.stringify(disclosures));
  }, [disclosures]);

  return (
    <CreditContext.Provider
      value={{
        creditInfo,
        setCreditId, // Exportamos esta función para actualizar el ID desde MisCreditos
        disclosures,
        due,
        setQuotaInfo
      }}
    >
      {children}
    </CreditContext.Provider>
  );
};

// Custom hook para usar el contexto
export const useCredit = () => useContext(CreditContext);
